import { Inject, Injectable } from '@angular/core';
import { CoreService_TOKEN } from '../tokens/injection-tokens';
import { ICoreService } from '../interfaces/core-service.interface';
import { TranslatedToastrService } from './translated-toastr.service';
import { ValidationHandlerService } from './validation-handler.service';
import { firstValueFrom } from 'rxjs';
import { BaseComponent } from '../components/base-components/base-component.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DataTableRequest, FileResponse, PivotConfig } from './api-services';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ExcelExportService extends BaseComponent {
    constructor(
        @Inject(CoreService_TOKEN)
        private coreService: ICoreService,
        private translatedToastrService: TranslatedToastrService,
        protected override validationHandlerService: ValidationHandlerService,
        protected override modalService: BsModalService,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

    public exportPivotExcel(model: PivotConfig) {
        this.handleSpinner(
            firstValueFrom(this.coreService.generatePivotExcelCommand(model))
                .then((fileStreamResult: any) => {
                    const blob = new Blob([fileStreamResult.data], { type: 'application/octet-stream' });

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileStreamResult.fileName;
                    a.click();
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
    }

    public exportExcel(type: string, request: DataTableRequest, providerId?: number) {
        if (!type) {
            this.translatedToastrService.warning('common.type_is_required', 'common.warning');
        } else {
            request.length = 0;
            this.handleSpinner(
                firstValueFrom(this.coreService.getExcelExportForType(type, providerId, request))
                    .then(res => {
                        this.downloadFile(res);
                    })
                    .catch(err => {
                        this.validationHandlerService.handleServerError(err);
                    })
            );
        }
    }

    public downloadFile(fileResponse: FileResponse) {
        const blob = fileResponse.data;
        const fileName = fileResponse.fileName || 'download.xlsx';

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
    }

    public toCamelCase(input: string): string {
        if (!input) {
            return '';
        }

        let words = input.split(' ');
        if (words.length === 1) {
            return words[0].charAt(0).toLowerCase() + words[0].slice(1);
        }

        return words
            .map((word, index) => {
                if (index === 0) {
                    return word.charAt(0).toLowerCase() + word.slice(1);
                } else {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
            })
            .join('');
    }
}
